// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {messages} from '@/i18n/dictionary';
import BootstrapVue from 'bootstrap-vue';
import vueResource from 'vue-resource';
import VueCookie from 'vue-cookie';
import {ClientTable, ServerTable} from '@/components/vuetable-2-kernel/compiled/index';

import Multiselect from 'vue-multiselect';
import IEcharts from 'vue-echarts-v3/src/full.js';
import VeeValidate from 'vee-validate';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import App from './App';
import {userRouter} from './router/user/';

// import * as Sentry from '@sentry/browser'
// import * as Integrations from '@sentry/integrations'
import store from './vuex/store';
import BackToTop from 'vue-backtotop';
import {Settings} from 'luxon';
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import spanish from 'vee-validate/dist/locale/es';
import VueAnalytics from 'vue-analytics';
import NProgress from 'vue-nprogress';
// import {VueReCaptcha} from 'vue-recaptcha-v3';
import {VueRecaptcha} from 'vue-recaptcha'; // RECAPTCHA V2

// Global vars for charts
export const GlobalCSS = {
  // Update this colors and fonts in assets/styles/libs.scss
  brandingColor: '#162236',
  secondaryColor: '#1d6898',
  borderColor: '#edeeef',
  fontFamily: '"Source Sans Pro", Verdana, Tahoma, sans-serif',
  fontSize: (localStorage.getItem('size') === 'Compact' || !localStorage.getItem('size')) ? 13 : 20
};

const moment = require('moment');
require('moment/locale/es');

Vue.use(BackToTop);

window.$ = require('jquery');
window.daterangepicker = require('daterangepicker');

let router = userRouter;

Vue.use(BootstrapVue);
Vue.use(vueResource);
Vue.use(VueCookie);
Vue.use(ServerTable);
Vue.use(ClientTable);
Vue.use(VueI18n);
Vue.use(require('vue-moment'), {moment});
Vue.use(VueRecaptcha, {siteKey: process.env.RECAPTCHA_SITE_KEY});

Settings.defaultLocale = 'es';
Vue.use(Datetime);

Vue.component('Multiselect', Multiselect);
Vue.component('IEcharts', IEcharts);

Vue.http.options.crossOrigin = true;
Vue.http.headers.common['Access-Control-Allow-Origin'] = '*';
Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin, Content-Disposition, Cache-Control';

Vue.use(VueAnalytics, {
  id: 'UA-114621522-3',
  router
});

/******************/
/* API URL CONFIG */
/******************/
const protocolHttp = (window.location.protocol === 'https:') ? 'https:' : 'http:';
const protocolWs = (window.location.protocol === 'https:') ? 'wss:' : 'ws:';

Vue.http.options.root = (process.env.PORT_API === 80)
  ? `${protocolHttp}//${process.env.HOST_API}/api/`
  : `${protocolHttp}//${process.env.HOST_API}:${process.env.PORT_API}/api/`;

Vue.http.options.ws_root = (process.env.PORT_API === 80)
  ? `${protocolWs}//${process.env.HOST_API}/ws/`
  : `${protocolWs}//${process.env.HOST_API}:${process.env.PORT_WS}/ws/`;

// Si estamos en el entorno 'development', activamos el devtools para poder debugar
if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

Vue.http.interceptors.push((request, next) => {
  if (request.method === 'GET' &&
    'ordering' in request.params &&
    'ascending' in request.params &&
    request.params.ascending === 1) {
    request.params.ordering = `-${request.params.ordering}`;
  }
  delete request.params.ascending;

  const csrftoken = Vue.cookie.get('kernel_token');

  if (csrftoken) {
    request.headers.set('Authorization', `Token ${csrftoken}`);

    next((response) => {
      if (response.status === 401) {
        if (response.data.detail === 'Invalid token.') {
          document.cookie = 'kernel_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
          document.location.replace('/');
        }
      }
    });
  } else if (request.url === 'auth/token/create/' || request.url === 'recaptcha/check/') {
    next();
  } else {
    if (request.url === 'check_reset_pwd/' || request.url === 'auth_custom/password/reset/' ||
      request.url === 'geoprovinciaempresa/' || request.url === 'entidad_search/' || request.url === 'upload_entidad/' ||
      request.url.includes('entidad/')) {
      next();
    } else {
      router.push('Login');
    }
  }
});

router.beforeEach((to, from, next) => {
  const csrftoken = Vue.cookie.get('kernel_token');
  if (csrftoken) {
    if (to.name !== 'Login') {
      next();
    } else {
      router.push('/');
    }
  } else {
    if (to.name === 'Login') {
      next();
    } else if (to.name === 'EmailResetPwd' || to.name === 'ResetPwd' || to.name === 'Form') {
      // console.log('name')
      next();
    } else {
      router.push('login');
    }
  }
});

// router.beforeEach((to, from, next) => {
//   if (to.meta.label) {
//     document.title = `${to.meta.label} - GeoVisor`
//   } else {
//     document.title = 'GeoVisor'
//   }
//   next()
// })

Vue.config.productionTip = false;

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: (localStorage.getItem('i18n') === 'EN') ? 'en' : localStorage.getItem('i18n') === 'ES' ? 'es' : 'en', // set locale
  messages // set locale messages
});

Vue.use(VeeValidate, {
  locale: 'es',
  dictionary: {
    es: {messages: spanish.messages}
  },
  inject: false
});

// Documentation: https://www.npmjs.com/package/vue-nprogress
Vue.use(NProgress, {
  latencyThreshold: 100, // Number of ms before progressbar starts showing, default: 100,
  router: true, // Show progressbar when navigating routes, default: true
  http: true // Show progressbar when doing Vue.http, default: true
});

/* eslint-disable no-new */

const nprogress = new NProgress();

new Vue({
  nprogress,
  el: '#app',
  router,
  store,
  i18n,
  components: {
    App
  },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js